import { render, staticRenderFns } from "./Mourns.vue?vue&type=template&id=c116967e&"
import script from "./Mourns.vue?vue&type=script&lang=js&"
export * from "./Mourns.vue?vue&type=script&lang=js&"
import style0 from "./Mourns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports